module.exports = __webpack_public_path__ + "img/int2.95e07c09.jpg";;
if (typeof window !== 'undefined') {
(window.__IMAGE_SIZES__ || (window.__IMAGE_SIZES__ = {}))[module.exports] = {"width":609,"height":454,"variants":[{"file":"img/int2-480w.90e4fbd97fc2.webp","width":480},{"file":"img/int2-609w.3597c5fc4543.webp","width":609}]};
}